export default __webpack_public_path__ + "static/samokat_promo_device-f51f56d5862ebd070af22dac7e7d1557.png";